<template>
  <v-layout class="product-item px-3 my-2" row wrap>
    <v-flex xs2>
      <h2><strong class="text-capitalize">{{ product.name }}</strong></h2>
      <small>{{ product.reference }}</small>
    </v-flex>
    <v-flex xs2 class="ml-auto">
      <v-combobox
        :attach="componentId"
        v-model="product.status_id"
        :items="statuses"
        label="Marcar como"
        text-field="name"
        persistent-hint>
      </v-combobox>
    </v-flex>
    <v-flex xs2 v-if="subStatuses.length">
      <v-combobox
        v-model="product.sub_status_id"
        :items="subStatuses"
        label="Sub status"
        text-field="name"
        persistent-hint>
      </v-combobox>
    </v-flex>
    <v-flex :xs4="subStatuses.length" :xs6="!subStatuses.length" v-if="product.status_id === 8" class="d-flex">
      <v-layout row wrap class="px-0">
        <template v-if="product.status_id === 8">
          <v-flex xs6>
            <v-text-field
              class="outline"
              name="monto"
              label="Monto"
              v-model="product.payment_promise_amount"
              solo>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-menu
              ref="datePicker1Ref"
              v-model="datePicker1"
              :nudge-top="50"
              lazy
              offset-y
              full-width
              class="d-inline-block"
              transition="scale-transition"
              min-width="290px">
              <v-text-field
                slot="activator"
                class="outline"
                :value="formatDate(product.payment_promise, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                prepend-icon="event"
                readonly
                flat
                solo/>
              <v-date-picker
                v-model="product.payment_promise"
                locale="es"
                :allowed-dates="allowedDates"
                color="k-orange-linear"/>
            </v-menu>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
    <v-flex xs2 v-if="[37, 44].includes(product.status_id) && dateField">
      <v-menu
        ref="datePicker1Ref"
        v-model="datePicker1"
        :nudge-top="50"
        lazy
        offset-y
        full-width
        class="d-inline-block"
        transition="scale-transition"
        min-width="290px">
        <v-text-field
          slot="activator"
          class="outline"
          :value="formatDate(product[dateField], 'YYYY-MM-DD', 'DD/MM/YYYY')"
          prepend-icon="event"
          readonly
          solo/>
        <v-date-picker
          v-model="product[dateField]"
          locale="es"
          :allowed-dates="allowedDates"
          color="k-orange-linear"/>
      </v-menu>
    </v-flex>
    <v-flex v-if="product.status_id" :xs2="product.status_id === 8" :xs6="[37, 44].includes(product.status_id)">
      <v-text-field
        class="outline"
        v-model="product.descrip"
        color="black"
        label="Comentario"
        solo/>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';
import formatDateMixin from '@/mixins/formatDate';
import VCombobox from '@/components/global/VCombobox';

export default {
  mixins: [formatDateMixin],
  components: {
    VCombobox,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    notification: {
      type: Object,
      required: true,
    },
    componentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      datePicker1: false,
    };
  },
  computed: {
    subStatuses() {
      if (this.product.status_id) {
        let subStatus = this.$store.getters.getSubStatusesByStatus(this.product.status_id);
        if (this.product.status_id === 8 && subStatus.length) {
          subStatus.unshift({
            id: -1,
            name: 'Compromiso normal',
          });
        }
        return subStatus;
      }
      return [];
    },
    dateField() {
      if (this.product.status_id === 37) {
        return 'next_contact';
      }
      if (this.product.status_id === 44) {
        return 'payment_intention';
      }
      return '';
    },
  },
  methods: {
    allowedDates(date) {
      const momentDate = moment(date, 'YYYY-MM-DD');
      const now = moment();
      let check = momentDate.isSameOrAfter(now.format('YYYY-MM-DD'));
      if (this.notification.max_commitment_days) {
        const maxDate = moment().add(parseInt(this.notification.max_commitment_days, 10) - 1, 'days');
        check = check && momentDate.isBefore(maxDate);
      }
      return check;
    },
  },
};
</script>

<style scoped>
.outline {
  border: 1px solid #393939;
  border-radius: 2px;
  box-shadow: 0px 0px 0px 0px transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/CallCenter/StatusItem.vue